import users from './users-info'
import authConfig from './auth-config'
import proxys from './proxys'
export default {
  users: users,
  authConfig: authConfig,
  proxys: proxys
}



// WEBPACK FOOTER //
// ./src/dev-variable/dev-variable.js